export default "__VITE_ASSET___tu8FOE1__"